import { render, staticRenderFns } from "./MemberChallengesTable.vue?vue&type=template&id=7b856042&lang=pug&"
import script from "./MemberChallengesTable.vue?vue&type=script&lang=js&"
export * from "./MemberChallengesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports